import React, { useState, useEffect } from "react";
import "./component.css";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import Sidebar from "../../Navigation/Sidebar/Sidebar";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import uploadImage from "../../../assests/uploadImage.svg";
import RemoveIcon from "@mui/icons-material/Remove";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  TextField,
  Checkbox,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

import Modal from "react-bootstrap/Modal";

import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";

const ComboDetailsUpdateComponent = (props) => {
  const setPrice = (newPrice, itemId) => {
    
    const updatedItems = props.selectedMvItems.map((item) =>
      item.id === itemId ? { ...item, price: newPrice } : item
    );
  
    props.setSelectedMvItems(updatedItems);
  };

  React.useEffect(() => {
    if (props.formData.mv_config) {
      props.setMvConfig(props.formData.mv_config);
    }
  }, [props.formData]);

  useEffect(() => {
    if (props.formData && Object.keys(props.formData).length > 0) {
      props.setFormData(props.formData);
    }
  }, [props.formData]);

  console.log(
    "mv config ",
    props.formData.selectedMvItems && props.formData.selectedMvItems
  );

  const navigate = useNavigate();

  const handleClick = () => navigate(-1);

  return (
    <div className="main-div" style={{ margin: "auto" }}>
      <Sidebar />

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Update Combo
          </h2>
        </div>

        <div
          style={{
            margin: "20px",
            overflowY: "auto",
            height: "92vh",
            width: "80vw",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            alignContent: "center",
            borderRadius: "14px",
          }}
        >
          <div style={{ height: "90vh", display:"flex", width:"70vw", alignItems:"center" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
            <div style={{ width: "26vw", margin: "auto", padding: "30px" }}>
            <TextField
                  name="name"
                  label="Name"
                  autoComplete="off"
                  fullWidth
                  variant="standard"
                  margin="normal"
                  value={(props.formData && props.formData.name) || ""}
                  onChange={props.handleInputChange}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />

                {props.errors && props.errors.name && (
                  <span className="errortext">
                    {props.errors && props.errors.name}
                  </span>
                )}

                <TextField
                  name="description"
                  label="Description"
                  variant="standard"
                  fullWidth
                  margin="normal"
                  value={props.formData.description || ""}
                  onChange={props.handleInputChange}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.description && (
                  <span className="errortext">
                    {props.errors && props.errors.description}
                  </span>
                )}

                <TextField
                  name="mrp"
                  label="MRP "
                  variant="standard"
                  fullWidth
                  margin="normal"
                  type="number"
                  value={props.formData.mrp || ""}
                  onChange={props.handleInputChange}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.mrp && (
                  <span className="errortext">
                    {props.errors && props.errors.mrp}
                  </span>
                )}
                <TextField
                  name="sellingPrice"
                  label="Selling Price"
                  variant="standard"
                  fullWidth
                  type="number"
                  margin="normal"
                  value={props.formData.sellingPrice || ""}
                  onChange={props.handleInputChange}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#14AE78",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#14AE78",
                    },
                  }}
                />
                {props.errors && props.errors.sellingPrice && (
                  <span className="errortext">
                    {props.errors && props.errors.sellingPrice}
                  </span>
                )}
                <div
                  style={{ display: "flex", gap: "10px", marginBottom: "20px" }}
                >
                  <DateTimePicker
                    name="startDate"
                    label="Starting Date"
                    value={props.formData.startDate || ""}
                    onChange={(date) => {
                      props.handleDateChange("startDate", date);
                    }}
                    minDate={new Date()}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        sx={{
                          "& .MuiInput-underline:before": {
                            borderBottomColor: "#14AE78",
                          },
                          "& .MuiInput-underline:after": {
                            borderBottomColor: "#14AE78",
                          },
                        }}
                      />
                    )}
                  />
                  {props.errors && props.errors.startDate && (
                    <span className="errortext">
                      {props.errors && props.errors.startDate}
                    </span>
                  )}
                  TO
                  <DateTimePicker
                    label="Expire Date"
                    value={props.formData.endDate || ""}
                    onChange={(date) => {
                      props.handleDateChange("endDate", date);
                    }}
                    minDate={props.formData.startDate || new Date()}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        sx={{
                          "& .MuiInput-underline:before": {
                            borderBottomColor: "#14AE78",
                          },
                          "& .MuiInput-underline:after": {
                            borderBottomColor: "#14AE78",
                          },
                        }}
                      />
                    )}
                  />
                </div>
                {props.errors && props.errors.date && (
                  <span className="errortext">
                    {props.errors && props.errors.date}
                  </span>
                )} 
                <div style={{ marginBottom: "20px", display: "flex" }}>
                  <p>Image</p>
                  {!(
                    props.formData.filePreview ||
                    props.formData.imagePreview ||
                    props.formData.imagePath ||
                    props.formData.image_url
                  ) ? (
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      style={{
                        borderStyle: "dashed",
                        color: "#14AE78",
                        borderColor: "#14AE78",
                        backgroundColor: "#63E2B61C",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <img src={uploadImage} alt="Upload icon" />
                        <p style={{ fontWeight: 600, color: "#14AE78" }}>
                          Choose file or drag here
                        </p>
                      </div>
                      <input
                        type="file"
                        hidden
                        onChange={props.handleFileChange}
                      />
                    </Button>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "200px",
                        height: "134px",
                        marginTop: "20px",
                      }}
                    >
                      <img
                        src={
                          props.formData.filePreview ||
                          props.formData.imagePreview ||
                          props.formData.imagePath ||
                          props.fetchedImageUrl
                        }
                        alt="Selected file preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "10px",
                          padding: "5px",
                          objectFit: "cover",
                        }}
                      />
                      {/* Remove button */}
                      <IconButton
                        onClick={props.handleRemoveFile}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "-25px",
                          border: "1px solid #111111",
                          padding: "2px",
                        }}
                      >
                        <CancelIcon
                          fontSize="small"
                          style={{ color: "#111111" }}
                        />
                      </IconButton>
                    </div>
                  )}
                </div>

                <Button
                  onClick={props.handleImageUpload}
                  variant="outlined"
                  color="success"
                >
                  upload image
                </Button>

                {props.errors && props.errors.file && (
                  <span className="errortext">
                    {props.errors && props.errors.file}
                  </span>
                )}

                  </div>
                  
              <div style={{ width: "26vw", marginTop: "-150px", padding: "40px" }}>
                
               
                
                <div style={{ marginBottom: "20px" }}>
                  <p style={{fontWeight:"600"}}>Apply on</p>
                  <div>
                    <Checkbox
                      name="applyOnKiosk"
                      style={{ color: "#14AE78" }}
                      checked={props.formData.applyOnKiosk || false}
                      onChange={(e) => props.handleCheckboxChange(e)}
                    />
                    Kiosk
                    <Checkbox
                      name="applyOnConsumerApp"
                      style={{ color: "#14AE78" }}
                      checked={props.formData.applyOnConsumerApp || false}
                      onChange={(e) => props.handleCheckboxChange(e)}
                    />
                    Consumer App
                  </div>
                  {props.errors && props.errors.selection && (
                    <span className="errortext">{props.errors.selection}</span>
                  )}
                </div>

                <div style={{ marginBottom: "20px", }}>
                  <div style={{ display: "flex" }}>
                    <TextField
                      label="Click to add MV ID"
                      fullWidth
                      disabled="true"
                      value={props.mvId}
                      onChange={(e) => props.setMvId(e.target.value)}
                      style={{ marginBottom: "10px", color: "#ccc" }}
                      variant="standard"
                      sx={{
                        "& .MuiInput-underline:before": {
                          borderBottomColor: "#14AE78",
                        },
                        "& .MuiInput-underline:after": {
                          borderBottomColor: "#14AE78",
                        },
                      }}
                    />

                    <Button
                      onClick={props.handleOpenModal}
                      style={{
                        marginBottom: "14px",
                        marginLeft: "-60px",
                        backgroundColor: "#14AE78",
                        color: "#fff",
                      }}
                      disabled={!props && props.mvId.trim()}
                    >
                      Add
                    </Button>
                  </div>
                  {props.errors && props.errors.mvConfig && (
                    <span className="errortext">
                      {props.errors && props.errors.mvConfig}
                    </span>
                  )}
 
                  <div style={{ display: "flex", flexDirection: "column" , width:"350px"}}>
                    {props.selectedMvItems &&
                    props.selectedMvItems.length > 0 ? (
                      props.selectedMvItems.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            // backgroundColor: item.isFetched ? "#e0f7fa" : "#fff",
                            borderRadius: "8px",
                            padding: "10px",
                            marginTop: "10px",
                            border: "1px solid #ccc",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{`ID: ${item.id}`}</span>
                          {/* <span>{`Price: ${item.mrp}`}</span> */}
                       
                          <TextField
                            name="sellingPrice"
                            label="Selling Price"
                            variant="standard"
                            fullWidth
                            type="number"
                            margin="normal"
                            value={item.actual_price || ""}
                            onChange={(e) => setPrice(e.target.value, item.id)}
                            // onChange={props.handleInputChange}
                            sx={{
                              "& .MuiInput-underline:before": {
                                borderBottomColor: "#14AE78",
                              },
                              "& .MuiInput-underline:after": {
                                borderBottomColor: "#14AE78",
                              },
                              width: "100px",
                            }}
                          />

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              backgroundColor: "#14AE78",
                              borderRadius: "5px",
                              padding: "5px",
                            }}
                          >
                            <IconButton
                              onClick={() => props.decrementQuantity(item.id)}
                              style={{ color: "#fff" }}
                            >
                              <RemoveIcon />
                            </IconButton>
                            <span style={{ color: "#fff" }}>
                              {item.quantity}
                            </span>
                            <IconButton
                              onClick={() => props.incrementQuantity(item.id)}
                              style={{ color: "#fff" }}
                            >
                              <AddIcon />
                            </IconButton>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p style={{ color: "#6B6B6B80" }}>No items available</p>
                    )}
                  </div>

                  <Dialog
                    open={props.modalOpen}
                    onClose={props.handleCloseModal}
                    maxWidth="md"
                    PaperProps={{
                      style: {
                        height: "80vh",
                        width: "70vw",
                      },
                    }}
                  >
                    <Typography
                      style={{
                        marginLeft: "30px",
                        color: "black",
                        fontWeight: 600,
                        fontSize: "18px",
                      }}
                    >
                      Select an MV ID
                    </Typography>

                    <DialogContent>
                      <TextField
                        label="Search MV ID"
                        fullWidth
                        type="number"
                        value={props.searchQuery}
                        onChange={props.handleSearchQueryChange}
                        variant="outlined"
                        style={{ marginBottom: "10px", width: "30vw" }}
                      />

                      <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                        <Table style={{ width: "100%" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ textAlign: "center" }}>
                                Select
                              </TableCell>
                              <TableCell style={{ textAlign: "center" }}>
                                ID
                              </TableCell>
                              <TableCell style={{ textAlign: "center" }}>
                                Product Name
                              </TableCell>
                              <TableCell style={{ textAlign: "center" }}>
                                Price
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {props.filteredMvList &&
                            props.filteredMvList.length > 0 ? (
                              props.filteredMvList.map((item, index) => (
                                <TableRow
                                  key={index}
                                  style={{
                                    height: "60px",
                                    textAlign: "center",
                                  }}
                                >
                                  <TableCell style={{ padding: "8px" }}>
                                    <Radio
                                      checked={
                                        props.formData.selectedMvItem?.id ===
                                        item.id
                                      }
                                      onChange={() =>
                                        props.handleSelectMvId(item)
                                      }
                                      value={item.id}
                                    />
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "30%" }}
                                    align="center"
                                  >
                                    {item.id}
                                  </TableCell>
                                  <TableCell style={{ width: "30%" }}>
                                    {item.variant_name}
                                  </TableCell>
                                  <TableCell style={{ width: "30%" }}>
                                    {item.mrp}
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  No results found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>

                <Modal
                  show={props.successModalOpen}
                  onHide={props.handleCloseSuccessModal}
                >
                  <Modal.Body>
                    <h4>Combo Created Successfully</h4>
                    <p>Your combo has been created!</p>
                    <button onClick={props.handleCloseSuccessModal}>OK</button>
                  </Modal.Body>
                </Modal>
              </div>
            </LocalizationProvider>
          </div>
        </div>
        <div
          style={{
            position: "fixed",
            bottom: "10px",
            width: "13vw",
            left: "43%",
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Button
            style={{ backgroundColor: "#14AE78", color: "#fff", width: "100%" }}
            onClick={props.handleUpdateComboApi}
            open={props.successModalOpen}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ComboDetailsUpdateComponent;
